

import { useEffect, useState } from 'react';
import { Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Color from '../../../data/Color';
import Flex from '../../../data/Flex';
import { dispatch, listen, unlisten } from '../../../dispatcher/Dispatcher';
import MapEvent from '../../../events/MapEvent';
import UIEvent from '../../../events/UIEvent';
import useHTMLTitle from '../../../hooks/useHTMLTitle';
import UIButton from '../../../ui/UIButton';
import UIContainer, { UIWhiteBox } from '../../../ui/UIContainer';
import UIFlex, { IFlex } from '../../../ui/UIFlex';
import { UITabs } from '../../../ui/UITabs';

import UITitle from '../../../ui/UITitle';
import View from '../../View';
import { CallHistory } from './CallHistory';
import './MainView.scss';
import { MainViewMap } from './MainViewMap';
import { Provisioning } from './Provisioning';
import { TransferNumber } from './TransferNumber';
import User from '../../../data/User';
import { ProviderContact } from './ProviderContact';
import AppEvent from '../../../events/AppEvent';

export interface IMainViewProps {

}


MainView.ID = "mainView";
MainView.PATH = "dashboard";
MainView.TITLE = "Dashboard";

export function MainView ($props: IMainViewProps) {

    useHTMLTitle(MainView.TITLE);

    let introBaseDelay = 0.5;

   // const [selectedTabId, setSelectedTabId] = useState(CallHistory.PATH);
    const [isFullscreen,setFullscreen] = useState(false);
    const [toggleTransitionsDisabled,setToggleTransitionsDisabled] = useState(false);


    const _onToggleFullscreen = ()=>{
        setFullscreen(($prev)=>{

            let newFullscreenState = !$prev;
            if(newFullscreenState){
                setToggleTransitionsDisabled(true);
            }else{
                window.setTimeout(()=>{
                    setToggleTransitionsDisabled(false);
                },300);
            }
            return newFullscreenState;
        });
        window.setTimeout(()=>{
            dispatch(UIEvent.UPDATE_TOGGLE_CONTAINER_SIZE);
        },300);
    }
    let navigation = useNavigate();

    useEffect(()=>{

        //starting route
        if(User.state.isECRCUser){
            navigation(CallHistory.PATH);
        }else{
            navigation(MainViewMap.PATH);
        }

        listen(MapEvent.TOGGLE_FULLSCREEN, _onToggleFullscreen);
        return ()=>{
            unlisten(MapEvent.TOGGLE_FULLSCREEN, _onToggleFullscreen);
        }
    },[]);
    

    let cn:string = isFullscreen?"isFullscreen":"";

    let leftColMaxWidth:number | string = 700;

    let toggleContainersDisabled:boolean=false;

    let selectedTabId = "";

    const location = useLocation();

    switch(location.pathname){
        case "/"+MainView.PATH+"/"+CallHistory.PATH:
            selectedTabId = CallHistory.PATH;
        break;
        case "/"+MainView.PATH+"/"+MainViewMap.PATH:
            selectedTabId = MainViewMap.PATH;
        break;
        default:
            selectedTabId = CallHistory.PATH;

            if(!User.state.isECRCUser){ 
              selectedTabId = MainViewMap.PATH;
            }
        break;     
    }



    let viewPadding=true;
    let disableToggleTransitions = false;
    let mainFlex:IFlex = {alignItems:Flex.FLEX_START, justifyContent:Flex.CENTER, style:{}, direction:Flex.ROW};

    if(isFullscreen){
        viewPadding=false;
        leftColMaxWidth = "none";
        mainFlex.justifyContent=Flex.STRETCH;
        mainFlex.alignItems=Flex.STRETCH;
        toggleContainersDisabled=true;
        mainFlex.style!.gap=0;
    }

    if(toggleTransitionsDisabled){
        disableToggleTransitions=true;
    }

    let tabCallHistory = {id:CallHistory.PATH, label:"Call History"};
    let tabMap = {id:MainViewMap.PATH, label:"Map"};

    let tabs = [];
    if(User.state.isECRCUser){
        tabs.push(tabCallHistory);
    }
    tabs.push(tabMap);

    return (
        <View padding={viewPadding} id={MainView.ID} className={cn} flex={mainFlex}>
            <UIContainer className='col1' flex={{justifyContent:Flex.STRETCH ,style:{}}}>
                <UIWhiteBox className={'tabbedSections'} noPadding animateIntro animateIntroDelay={introBaseDelay+0.1} flex={{fullWidth:true}}>
                    <UITabs renderAsLinks style={UITabs.STYLE_AS_WHITE_DS_TABS} onChange={($id:string)=>{
                      //  setSelectedTabId($id); //not needed because tabs render as links
                    }} selectedId={selectedTabId} options={tabs}/>
                    <div className={"sectionContainer "+"show_"+selectedTabId}>
                        {User.state.isECRCUser && (
                            <CallHistory visible={selectedTabId===CallHistory.PATH}/>
                        )}
                        <MainViewMap visible={selectedTabId===MainViewMap.PATH} isFullscreen={isFullscreen}/>
                        {/*
                            <Routes>
                                {User.state.isECRCUser && (
                                    <Route path={CallHistory.PATH} element={<CallHistory/>}/>
                                )}
                                <Route path={MainViewMap.PATH} element={<MainViewMap isFullscreen={isFullscreen}/>}/>
                            </Routes> 
                        */}    

                    </div>   
                </UIWhiteBox>
            </UIContainer>
            <UIContainer className='col2' flex={{style:{}}}>
                <Provisioning introDelay={introBaseDelay+0.2}/>
            </UIContainer>
            {/*
            <UIContainer className='rightCol' flex={{style:{}}}>
                <ProviderContact introDelay={introBaseDelay+0.4}/>
            </UIContainer>

            */}
        </View>
    );
}
